import './index.css'
import cn from 'clsx'
import * as React from 'react'
import Icon, { IconKey } from 'components/ui/icon'
import PopupContainer from './popup'
type OwnProps = {
  label: string
  style: string
  icon?: IconKey
  title?: string
  onClick: (...args: Array<any>) => any
  active: boolean
  configComponent: React.ReactElement<any> | null | undefined
  popupStyle?: string
}
type OwnState = {
  showConfig: boolean
}

class RichTextToolbarButton extends React.Component<OwnProps, OwnState> {
  state: OwnState = {
    showConfig: false,
  }
  _toggleConfig: () => void = () => {
    this.setState({
      showConfig: !this.state.showConfig,
    })
  }
  _hidePopup: () => void = () => {
    if (this.state.showConfig)
      this.setState({
        showConfig: false,
      })
  }

  render(): React.ReactElement<'span'> {
    const {
      label,
      title,
      style,
      icon,
      onClick,
      active,
      configComponent,
      popupStyle,
    } = this.props
    return (
      <span>
        <span
          key={label}
          className={cn('rich-text-toolbar__button', style, {
            'rich-text-toolbar__button--active': active,
          })}
          onClick={configComponent ? this._toggleConfig : onClick}
          title={title}
        >
          {icon ? <Icon type={icon} width="1.3em" height="1.3em" /> : label}
          {this.state.showConfig && (
            <div
              onClick={e => {
                e.stopPropagation()
              }}
            >
              <PopupContainer popupStyle={popupStyle} onHide={this._hidePopup}>
                {configComponent &&
                  React.cloneElement(configComponent, {
                    onSubmit: data => {
                      // let's override `onSubmit` logic
                      if (style !== 'color' && style !== 'bgcolor')
                        this._hidePopup()
                      // and still call the original fn
                      configComponent.props.onSubmit(data)
                    },
                    onCancel: () => this._hidePopup(),
                  })}
              </PopupContainer>
            </div>
          )}
        </span>
      </span>
    )
  }
}

export default RichTextToolbarButton
